import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, Scene } from 'react-scrollmagic';

import BuildIcon from './icons/build';
import CreateEditIcon from './icons/create-edit';
import PublishIcon from './icons/publish';
import ViewIcon from './icons/view';
import SectionTitle from './section-title';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(23, 0)
    }
  },
  animate: {
    position: 'relative',
    top: 20,
    transition:
      'opacity 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955), top 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)',
    opacity: 0
  },
  show: {
    top: 0,
    opacity: 1
  },
  title: {
    transitionDelay: '0.1s',
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(14)
    }
  },
  icon: {
    marginBottom: theme.spacing(6),
    fontSize: 76
  },
  text: {
    width: '100%',
    fontSize: 16
  },
  d0: {
    transitionDelay: '0.4s'
  },
  d1: {
    transitionDelay: '0.7s'
  },
  d2: {
    transitionDelay: '1.0s'
  },
  d3: {
    transitionDelay: '1.3s'
  }
}));

const AppWorkContent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <section className={classes.root}>
      <Container maxWidth="xl">
        <Controller>
          <Scene
            classToggle={[`.${classes.animate}`, `${classes.show}`]}
            triggerElement="#whiteLabelAW"
            indicators={false}
            reverse={false}
          >
            <div id="whiteLabelAW">
              <SectionTitle
                className={clsx(classes.title, classes.animate)}
                title={t('whiteLabelPage.appWork.title')}
                align="center"
              />
              <Grid container spacing={10}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  className={clsx(classes.d0, classes.animate)}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <BuildIcon className={classes.icon} />
                    <Typography
                      className={classes.text}
                      variant="body2"
                      align="center"
                    >
                      {t('whiteLabelPage.appWork.build')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  className={clsx(classes.d1, classes.animate)}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <CreateEditIcon className={classes.icon} />
                    <Typography
                      className={classes.text}
                      variant="body2"
                      align="center"
                    >
                      {t('whiteLabelPage.appWork.create')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  className={clsx(classes.d2, classes.animate)}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <PublishIcon className={classes.icon} />
                    <Typography
                      className={classes.text}
                      variant="body2"
                      align="center"
                    >
                      {t('whiteLabelPage.appWork.publish')}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  className={clsx(classes.d3, classes.animate)}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                  >
                    <ViewIcon className={classes.icon} />
                    <Typography
                      className={classes.text}
                      variant="body2"
                      align="center"
                    >
                      {t('whiteLabelPage.appWork.view')}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </Scene>
        </Controller>
      </Container>
    </section>
  );
};

export default AppWorkContent;
